import React from 'react';
import className from 'classnames';
import moment from 'moment';
import {get} from 'lodash';

import {
  canEdit,
} from '../lib/policies';

import TableHeader from './TableHeader';
import ModalDelete from './ModalDelete';
import BounceEmailBadge from './BounceEmailBadge';

const EmailReputationsList = ({
  emailReputations = [],
  total = 0,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Email Reputations list</h2>
        </div>
      </div>

      <div className='Table Table--email-reputations-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Email'
            },
            {
              label: 'Status'
            },
            {
              label: 'Reason'
            },
            {
              label: 'Create At'
            },
            {
              label: 'Manage',
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {emailReputations.map((emailReputation) => (
          <div
            className='Table__row'
            key={`${emailReputation.id}_${emailReputation.createdAt}`}
            data-x={emailReputation}
          >
            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/${gon.currentProvider}/users/search?query[email]=${emailReputation.email}`}
              >
                {emailReputation.email}
              </a>
            </div>

            <div className='Table__col'>
              <BounceEmailBadge status={emailReputation.status} />
            </div>
            <div className='Table__col'>{emailReputation.reason}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: emailReputation.createdAt !== null ?
                    moment(emailReputation.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              <div className='Table__controls'>
                {canEdit('emailReputation') &&
                  <ModalDelete
                    type='email_reputation'
                    id={get(emailReputation, 'id')}
                    klassName='Table__controls__a Table__controls__a--trash'
                    reload
                    hideText
                  />
                }
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default EmailReputationsList
